/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import Dropdown from '../filters/Dropdown';
import { FiLayers } from 'react-icons/fi';
import AddContract from './AddContract';

const Contracts = () => {
  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to toggle the modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // State to manage editable rows
  const [editableRows, setEditableRows] = useState([
    { id: 1, textMobile: 'Add', isEditingMobile: false },
    // Add other rows if needed
  ]);

  const handleMobileClick = (id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, isEditingMobile: true } : row
      )
    );
  };

  const handleMobileChange = (e, id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, textMobile: e.target.value } : row
      )
    );
  };

  const handleMobileBlur = (id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, isEditingMobile: false } : row
      )
    );
  };

  const handleMobileKeyPress = (e, id) => {
    if (e.key === 'Enter') {
      handleMobileBlur(id);
    }
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2">
          <h5 className="text-muted col-2">
            Contracts
            <i
              className="mdi mdi-information-outline font-18 ml-1"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Contracts equal assigning projects to members, setting their hourly rate, weekly hour limit, and screenshot mode."
              style={{ cursor: 'pointer' }}
            ></i>
          </h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            <Button
              className="d-flex align-items-center text-white"
              color="purple"
              size="sm"
              onClick={toggleModal}
            >
              <i className="mdi mdi-plus mr-2"></i> Create contract
            </Button>
            <Button
              outline
              className="d-flex align-items-center"
              color="danger"
              size="sm"
            >
              <i className="fa fa-trash mr-2"></i> Delete All
            </Button>
          </div>
        </div>
        <AddContract open={isModalOpen} onClose={toggleModal} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-20">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="d-flex justify-content-start align-items-center mt-2">
                          <Dropdown
                            label="Projects"
                            items={[
                              'Action',
                              'Another action',
                              'Something else here',
                            ]}
                            icon={'mdi mdi-briefcase'}
                          />
                          <Dropdown
                            label="Members"
                            items={[
                              'Action',
                              'Another action',
                              'Something else here',
                            ]}
                            icon={'mdi mdi-account-multiple'}
                          />
                          <Dropdown
                            label="Teams"
                            items={['Team A', 'Team B', 'Team C']}
                            icon={'mdi mdi-account-multiple-outline'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-b-20">
                <div className="card-body">
                  <div>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Assigned to</th>
                          <th>Project</th>
                          <th>Hourly Rate</th>
                          <th>Weekly Limit</th>
                          <th>Screenshot mode</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {editableRows.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <div>
                                <span className="border rounded p-1 text-white bg-info">
                                  SK
                                </span>
                                <span className="ml-1">Subeesh Kannath</span>
                              </div>
                            </td>
                            <td>
                              <span>
                                {' '}
                                <FiLayers className="text-muted" /> Getting
                                Started with WebWork
                              </span>
                            </td>
                            <td>
                              <div className="d-flex">
                                <select
                                  className="form-control"
                                  style={{ width: '150px' }}
                                >
                                  <option>Custom Rate</option>
                                  <option value="true">Member Rate</option>
                                  <option value="false">Project Rate</option>
                                </select>
                                <input
                                  className="form-control"
                                  type="number"
                                  placeholder="0"
                                  style={{ width: '50px' }}
                                />
                              </div>
                            </td>
                            <td>
                              <div
                                className="col-4 d-flex justify-content-between align-items-center border rounded "
                                style={{ width: '150px', padding: '4px 10px' }}
                              >
                                <i
                                  className="typcn typcn-pencil text-purple font-18 pr-2"
                                  style={{ borderRight: '1px solid #D2E0FB' }}
                                ></i>
                                {item.isEditingMobile ? (
                                  <input
                                    type="number"
                                    value={item.textMobile}
                                    onChange={(e) =>
                                      handleMobileChange(e, item.id)
                                    }
                                    onBlur={() => handleMobileBlur(item.id)}
                                    onKeyPress={(e) =>
                                      handleMobileKeyPress(e, item.id)
                                    }
                                    className="edit_input1"
                                    autoFocus
                                  />
                                ) : (
                                  <span
                                    onClick={() => handleMobileClick(item.id)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {item.textMobile}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>
                              <div style={{ width: '150px' }}>
                                <select className="form-control">
                                  <option>Screenshot</option>
                                  <option value="true">
                                    Default Screenshot
                                  </option>
                                  <option value="false">No Screenshot</option>
                                  <option value="fa">Blur Screenshot</option>
                                </select>
                              </div>
                            </td>
                            <td>
                              <div>
                                <i
                                  className="dripicons-media-pause font-16"
                                  style={{ cursor: 'pointer' }}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Pause"
                                ></i>
                                <i
                                  className=" mdi mdi-close font-20 ml-3 text-danger"
                                  style={{ cursor: 'pointer' }}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Unassign user"
                                ></i>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default Contracts;
